module.exports = __webpack_public_path__ + "static/media/appstore.ee573fc4.svg";